export const iconFontAwesomeHouseholdHouseChimneyUser = (
	<i className="fa-solid fa-house-chimney-user"></i>
);
